import clsx from 'clsx';
import React from 'react';
import { motion } from 'framer-motion';
import { alpha, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { LogoOutline } from './LogoOutline';

const TRANSITION = {
  ease: 'linear',
  duration: 3.2,
  loop: Infinity
};

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20%',
    backgroundColor: theme.palette.background.default
  },
  box: {
    position: 'absolute',
    borderRadius: '50%'
  },
  inner: {
    width: 100,
    height: 100,
    border: `solid 3px ${alpha(theme.palette.primary.dark, 0.72)}`
  },
  outside: {
    width: 120,
    height: 120,
    border: `solid 8px ${alpha(theme.palette.primary.dark, 0.48)}`
  }
}));

type Props = {
  className?: string;
};

function LoadingScreen(props: Props) {
  const { className, ...other } = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...other}>
      <Box sx={{ height: 64 }}>
        <LogoOutline thick={true} />
      </Box>
      <motion.div
        animate={{
          scale: [1.1, 1, 1.1],
          opacity: [0.25, 1, 0.25],
          borderRadius: '50%'
        }}
        transition={TRANSITION}
        className={clsx(classes.box, classes.inner)}
      />
      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          opacity: [1, 0.25, 1],
          borderRadius: '50%'
        }}
        transition={{
          ease: 'linear',
          duration: 3.2,
          loop: Infinity
        }}
        className={clsx(classes.box, classes.outside)}
      />
    </div>
  );
}

export default LoadingScreen;
